import { render } from "./SettingsLabelGroups.vue?vue&type=template&id=a766f95e"
import script from "./SettingsLabelGroups.vue?vue&type=script&lang=js"
export * from "./SettingsLabelGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__